/**
 * The initial-letter avatar beside the staff who counted a SKU. Decorative —
 * the name is rendered as text next to it, so this is aria-hidden.
 *
 * Lifted out of `StocktakeLocationDetailScreen` so the cross-location search
 * rows can use the same one.
 */
const AVATAR_COLORS = [
  'bg-primary',
  'bg-[#e85d75]',
  'bg-[#7ccc78]',
  'bg-[#f5a623]',
  'bg-[#9b59b6]',
  'bg-[#1abc9c]',
]

function StaffAvatar({ name, index }: Readonly<{ name: string; index: number }>) {
  const color = AVATAR_COLORS[index % AVATAR_COLORS.length]
  return (
    <div
      className={`flex size-5 shrink-0 items-center justify-center rounded-full ${color}`}
      aria-hidden="true"
    >
      <span className="text-[10px] font-bold text-white">{name.charAt(0)}</span>
    </div>
  )
}

export { AVATAR_COLORS, StaffAvatar }
